import React, { FC, ChangeEvent } from 'react';
import { useFormikContext } from 'formik';
import { Grid, Switch, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { SocialAccountIcon } from 'components';

import { INetwork, IShare } from '../types';
import Commentary from './Commentary';

interface IProps {
  network: INetwork;
}

const useStyles = makeStyles({
  title: {
    position: 'relative',
    top: 2,
  },
});

const ActiveUnauth: FC<IProps> = ({ network }) => {
  const classes = useStyles();
  const { values, setFieldValue } = useFormikContext<IShare>();
  const { provider } = network;

  const item = values[provider];
  const { active } = item;

  function toggleNetwork(event: ChangeEvent<HTMLInputElement>) {
    setFieldValue(`${network.provider}.active`, event.target.checked);
  }

  return (
    <Grid container alignItems="baseline" justify="space-between">
      <Grid item>
        <SocialAccountIcon size={24} active={active} provider={provider} />
      </Grid>
      <Grid item xs>
        <Grid container alignItems="center">
          <Grid item xs>
            <Typography variant="subtitle2" className={classes.title}>
              {network.name}
            </Typography>
          </Grid>
          <Grid item>
            <Switch checked={active} onChange={toggleNetwork} />
          </Grid>
        </Grid>
        {active && (
          <Grid container item xs>
            <Commentary network={network} />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default ActiveUnauth;
